export type TOKENS = {
    instagramRefreshToken?: string,
    googleRefreshToken?: string,
}

export const THEMES = {
  DARK: 'dark',
  LIGHT: 'light',
};
